module.exports = __webpack_public_path__ + "4bf9595e09d83c5af4db9f3bcc10deb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/black-and-white-images/B_W4.jpg
// module id = 3304
// module chunks = 0